import { LucideIcon } from 'lucide-react';
import { formatNumber } from '@/lib/utils';

interface MetricBoxProps {
  title: string;
  value: number;
  subtitle?: string;
  format?: 'euro' | 'percentage' | 'number';
  icon?: LucideIcon;
  valueColor?: string;
}

export function MetricBox({
  title,
  value,
  subtitle,
  format = 'euro',
  icon: Icon,
  valueColor = 'text-adv-primary',
}: MetricBoxProps) {
  const formattedValue = formatNumber(value, format);

  return (
    <div className="adv-card adv-card--kpi p-5 font-adv-sans">
      <div className="flex items-center justify-between gap-3 mb-2">
        <h3 className="adv-kpi__label">{title}</h3>
        {Icon && <Icon className="text-adv-tertiary shrink-0" size={20} />}
      </div>
      <p className={`adv-kpi__value ${valueColor}`}>{formattedValue}</p>
      {subtitle && <p className="text-adv-body-s text-adv-secondary mt-1">{subtitle}</p>}
    </div>
  );
}
